import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { MultipleChoiceQuestion } from "../core";

const QUESTION_ID = "hypertension";

declare module "@/contexts" {
  interface SurveyAnswers {
    hypertension?: string;
  }
}

const HypertensionQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "yes", text: t("hypertension.options.yes") },
    { id: "no", text: t("hypertension.options.no") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("hypertension.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_HYPERTENSION: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: HypertensionQuestion,
};

export const Q_RETRIAGE_HYPERTENSION: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: HypertensionQuestion,
};
